import { useLanguage } from './useLanguage';
import * as fr from '../locales/fr';
import * as ar from '../locales/ar';
import * as es from '../locales/es';

const translations = {
  fr,
  ar,
  es
};

export const useTranslation = (namespace) => {
  const { lang } = useLanguage();
  
  // Vérification de sécurité pour éviter les erreurs
  if (!lang || !translations[lang]) {
    console.warn(`Language '${lang}' not found, falling back to 'fr'`);
    return translations.fr?.[namespace] || {};
  }
  
  const namespaceTranslations = translations[lang][namespace];
  
  if (!namespaceTranslations) {
    console.warn(`Namespace '${namespace}' not found for language '${lang}', falling back to 'fr'`);
    return translations.fr?.[namespace] || {};
  }
  
  return namespaceTranslations;
}; 